<template>
  <!-- Figma S&R flow pill: white, 40px, 1px border, 30px icon circle (Back: grey on the left, Next: teal on the right);
       hover fills the pill with its colour and inverts the icon circle (not when disabled); below laptop (touch, no hover)
       that filled look is the normal state -->
  <button type="button"
    class="group flex items-center gap-[10px] h-[40px] rounded-full border-1 font-roboto font-semibold text-[14px] whitespace-nowrap disabled:opacity-50 transition-colors disabled:cursor-not-allowed"
    :class="[isBack ? 'pl-[5px] pr-[15px] largeDesktop:pr-[20px] border-[#666666] !bg-[#666] text-[#fff] laptop:!bg-[#fff] laptop:text-[#666666] laptop:hover:!bg-[#666] laptop:hover:text-[#fff]' : 'pl-[15px] largeDesktop:pl-[20px] pr-[5px] border-[#00B7C2] bg-[#00B7C2] text-[#fff] laptop:!bg-[#fff] laptop:text-[#00B7C2] laptop:enabled:hover:!bg-[#00B7C2] laptop:enabled:hover:text-[#fff]', buttonClass]">
    <span v-if="isBack"
      class="w-[30px] h-[30px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#fff] text-[#666] laptop:bg-[#666666] laptop:text-[#fff] laptop:group-hover:bg-[#fff] laptop:group-hover:text-[#666]">
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="w-[18px] h-[18px]">
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M10 18L4 12L10 6M4 12H14.5M20 12H17.5" />
      </svg>
    </span>
    <slot>{{ isBack ? 'Back' : 'Next' }}</slot>
    <span v-if="!isBack && !isSubmit" :class="arrowCircleClass"
      class="w-[30px] h-[30px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#fff] text-[#00B7C2] laptop:bg-[#00B7C2] laptop:text-[#fff] laptop:group-enabled:group-hover:bg-[#fff] laptop:group-enabled:group-hover:text-[#00B7C2]">
      
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M4 12H6.5M14 18L20 12L14 6M20 12H9.5" />
      </svg>
    </span>
    <span v-if="isSubmit" :class="arrowCircleClass"
      class="w-[30px] h-[30px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#fff] text-[#00B7C2] laptop:bg-[#00B7C2] laptop:text-[#fff] laptop:group-enabled:group-hover:bg-[#fff] laptop:group-enabled:group-hover:text-[#00B7C2]">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill="currentColor"
          d="M2.4472 1.1056L22.4472 11.1056C22.786 11.275 23 11.6212 23 12C23 12.3788 22.786 12.725 22.4472 12.8944L2.4472 22.8944C2.3084 22.9639 2.1552 23 2 23C1.4477 23 1 22.5523 1 22C1 21.9378 1.0058 21.8758 1.0173 21.8147L2.868 12L1.0173 2.1853C1.0058 2.1242 1 2.0622 1 2C1 1.4477 1.4477 1 2 1C2.1552 1 2.3084 1.0361 2.4472 1.1056ZM12.9428 12L2.5852 10.5L2.868 12L2.5852 13.5L12.9428 12Z" />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    // 'back' | 'next'
    variant: { type: String, default: 'next' },
    buttonClass: { type: String, default: "" },
    arrowCircleClass: { type: String, default: "" },
  },
  computed: {
    isBack() {
      return this.variant === 'back';
    },
    isSubmit() {
      return this.variant === 'submit';
    },
  },
};
</script>
